module.exports = __webpack_public_path__ + "img/racecourse-mauritius-turf-2400.051c11da.svg";